export const Monsters = [
    ['Frowning Gaper', JSON.stringify({
      id: '10',
      subtype: '0',
      variant: '0',
    })],
    ['Gaper', JSON.stringify({
      id: '10',
      subtype: '0',
      variant: '1',
    })],
    ['Flaming Gaper', JSON.stringify({
      id: '10',
      subtype: '0',
      variant: '2',
    })],
    ['Gusher', JSON.stringify({
      id: '11',
      subtype: '0',
      variant: '0',
    })],
    ['Pacer', JSON.stringify({
      id: '11',
      subtype: '0',
      variant: '1',
    })],
    ['Horf', JSON.stringify({
      id: '12',
      subtype: '0',
      variant: '0',
    })],
    ['Fly', JSON.stringify({
      id: '13',
      subtype: '0',
      variant: '0',
    })],
    ['Pooter', JSON.stringify({
      id: '14',
      subtype: '0',
      variant: '0',
    })],
    ['Super Pooter', JSON.stringify({
      id: '14',
      subtype: '0',
      variant: '1',
    })],
    ['Clotty', JSON.stringify({
      id: '15',
      subtype: '0',
      variant: '0',
    })],
    ['Clot', JSON.stringify({
      id: '15',
      subtype: '0',
      variant: '1',
    })],
    ['I.Blob', JSON.stringify({
      id: '15',
      subtype: '0',
      variant: '2',
    })],
    ['Mulligan', JSON.stringify({
      id: '16',
      subtype: '0',
      variant: '0',
    })],
    ['Mulligoon', JSON.stringify({
      id: '16',
      subtype: '0',
      variant: '1',
    })],
    ['Mulliboom', JSON.stringify({
      id: '16',
      subtype: '0',
      variant: '2',
    })],
    ['Shopkeeper', JSON.stringify({
      id: '17',
      subtype: '0',
      variant: '0',
    })],
    ['Secret Room Keeper', JSON.stringify({
      id: '17',
      subtype: '0',
      variant: '1',
    })],
    ['Error Room Keeper', JSON.stringify({
      id: '17',
      subtype: '0',
      variant: '2',
    })],
    ['Special Shopkeeper', JSON.stringify({
      id: '17',
      subtype: '0',
      variant: '3',
    })],
    ['Special Secret Room Keeper', JSON.stringify({
      id: '17',
      subtype: '0',
      variant: '4',
    })],
    ['Attack Fly', JSON.stringify({
      id: '18',
      subtype: '0',
      variant: '0',
    })],
    ['Maggot', JSON.stringify({
      id: '21',
      subtype: '0',
      variant: '0',
    })],
    ['Hive', JSON.stringify({
      id: '22',
      subtype: '0',
      variant: '0',
    })],
    ['Drowned Hive', JSON.stringify({
      id: '22',
      subtype: '0',
      variant: '1',
    })],
    ['Charger', JSON.stringify({
      id: '23',
      subtype: '0',
      variant: '0',
    })],
    ['My Shadow', JSON.stringify({
      id: '23',
      subtype: '1',
      variant: '0',
    })],
    ['Drowned Charger', JSON.stringify({
      id: '23',
      subtype: '0',
      variant: '1',
    })],
    ['Dank Charger', JSON.stringify({
      id: '23',
      subtype: '0',
      variant: '2',
    })],
    ['Globin', JSON.stringify({
      id: '24',
      subtype: '0',
      variant: '0',
    })],
    ['Gazing Globin', JSON.stringify({
      id: '24',
      subtype: '0',
      variant: '1',
    })],
    ['Dank Globin', JSON.stringify({
      id: '24',
      subtype: '0',
      variant: '2',
    })],
    ['Boom Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '0',
    })],
    ['Red Boom Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '1',
    })],
    ['Drowned Boom Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '2',
    })],
    ['Maw', JSON.stringify({
      id: '26',
      subtype: '0',
      variant: '0',
    })],
    ['Red Maw', JSON.stringify({
      id: '26',
      subtype: '0',
      variant: '1',
    })],
    ['Psychic Maw', JSON.stringify({
      id: '26',
      subtype: '0',
      variant: '2',
    })],
    ['Host', JSON.stringify({
      id: '27',
      subtype: '0',
      variant: '0',
    })],
    ['Red Host', JSON.stringify({
      id: '27',
      subtype: '0',
      variant: '1',
    })],
    ['Hopper', JSON.stringify({
      id: '29',
      subtype: '0',
      variant: '0',
    })],
    ['Trite', JSON.stringify({
      id: '29',
      subtype: '0',
      variant: '1',
    })],
    ['Boil', JSON.stringify({
      id: '30',
      subtype: '0',
      variant: '0',
    })],
    ['Gut', JSON.stringify({
      id: '30',
      subtype: '0',
      variant: '1',
    })],
    ['Sack', JSON.stringify({
      id: '30',
      subtype: '0',
      variant: '2',
    })],
    ['Spitty', JSON.stringify({
      id: '31',
      subtype: '0',
      variant: '0',
    })],
    ['Brain', JSON.stringify({
      id: '32',
      subtype: '0',
      variant: '0',
    })],
    ['Fire Place', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '0',
    })],
    ['Red Fire Place', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '1',
    })],
    ['Blue Fire Place', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '2',
    })],
    ['Purple Fire Place', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '3',
    })],
    ['Leaper', JSON.stringify({
      id: '34',
      subtype: '0',
      variant: '0',
    })],
    ['Mr. Maw', JSON.stringify({
      id: '35',
      subtype: '0',
      variant: '0',
    })],
    ['Mr. Maw Head', JSON.stringify({
      id: '35',
      subtype: '0',
      variant: '1',
    })],
    ['Mr. Red Maw', JSON.stringify({
      id: '35',
      subtype: '0',
      variant: '2',
    })],
    ['Mr. Red Maw Head', JSON.stringify({
      id: '35',
      subtype: '0',
      variant: '3',
    })],
    ['Mr. Maw Neck', JSON.stringify({
      id: '35',
      subtype: '0',
      variant: '10',
    })],
    ['Baby', JSON.stringify({
      id: '38',
      subtype: '0',
      variant: '0',
    })],
    ['Angelic Baby', JSON.stringify({
      id: '38',
      subtype: '0',
      variant: '1',
    })],
    ['Vis', JSON.stringify({
      id: '39',
      subtype: '0',
      variant: '0',
    })],
    ['Double Vis', JSON.stringify({
      id: '39',
      subtype: '0',
      variant: '1',
    })],
    ['Chubber', JSON.stringify({
      id: '39',
      subtype: '0',
      variant: '2',
    })],
    ['Scarred Double Vis', JSON.stringify({
      id: '39',
      subtype: '0',
      variant: '3',
    })],
    ['Guts', JSON.stringify({
      id: '40',
      subtype: '0',
      variant: '0',
    })],
    ['Scarred Guts', JSON.stringify({
      id: '40',
      subtype: '0',
      variant: '1',
    })],
    ['Knight', JSON.stringify({
      id: '41',
      subtype: '0',
      variant: '0',
    })],
    ['Selfless Knight', JSON.stringify({
      id: '41',
      subtype: '0',
      variant: '1',
    })],
    ['Stone Grimace', JSON.stringify({
      id: '42',
      subtype: '0',
      variant: '0',
    })],
    ['Vomit Grimace', JSON.stringify({
      id: '42',
      subtype: '0',
      variant: '1',
    })],
    ['Poky', JSON.stringify({
      id: '44',
      subtype: '0',
      variant: '0',
    })],
    ['Slide', JSON.stringify({
      id: '44',
      subtype: '0',
      variant: '1',
    })],
    ['Dople', JSON.stringify({
      id: '53',
      subtype: '0',
      variant: '0',
    })],
    ['Evil Twin', JSON.stringify({
      id: '53',
      subtype: '0',
      variant: '1',
    })],
    ['Flaming Hopper', JSON.stringify({
      id: '54',
      subtype: '0',
      variant: '0',
    })],
    ['Leech', JSON.stringify({
      id: '55',
      subtype: '0',
      variant: '0',
    })],
    ['Kamikaze Leech', JSON.stringify({
      id: '55',
      subtype: '0',
      variant: '1',
    })],
    ['Holy Leech', JSON.stringify({
      id: '55',
      subtype: '0',
      variant: '2',
    })],
    ['Lump', JSON.stringify({
      id: '56',
      subtype: '0',
      variant: '0',
    })],
    ['MemBrain', JSON.stringify({
      id: '57',
      subtype: '0',
      variant: '0',
    })],
    ['Mama Guts', JSON.stringify({
      id: '57',
      subtype: '0',
      variant: '1',
    })],
    ['Para-Bite', JSON.stringify({
      id: '58',
      subtype: '0',
      variant: '0',
    })],
    ['Scarred Para-Bite', JSON.stringify({
      id: '58',
      subtype: '0',
      variant: '1',
    })],
    ['Fred', JSON.stringify({
      id: '59',
      subtype: '0',
      variant: '0',
    })],
    ['Eye', JSON.stringify({
      id: '60',
      subtype: '0',
      variant: '0',
    })],
    ['Bloodshot Eye', JSON.stringify({
      id: '60',
      subtype: '0',
      variant: '1',
    })],
    ['Sucker', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '0',
    })],
    ['Spit', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '1',
    })],
    ['Soul Sucker', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '2',
    })],
    ['Death Scythe', JSON.stringify({
      id: '66',
      subtype: '0',
      variant: '10',
    })],
    ['Peep Eye', JSON.stringify({
      id: '68',
      subtype: '0',
      variant: '10',
    })],
    ['Bloat Eye', JSON.stringify({
      id: '68',
      subtype: '0',
      variant: '11',
    })],
    ['Embryo', JSON.stringify({
      id: '77',
      subtype: '0',
      variant: '0',
    })],
    ['Moms Guts', JSON.stringify({
      id: '78',
      subtype: '0',
      variant: '10',
    })],
    ['Umbilical Cord', JSON.stringify({
      id: '79',
      subtype: '0',
      variant: '20',
    })],
    ['Moter', JSON.stringify({
      id: '80',
      subtype: '0',
      variant: '0',
    })],
    ['Spider', JSON.stringify({
      id: '85',
      subtype: '0',
      variant: '0',
    })],
    ['Keeper', JSON.stringify({
      id: '86',
      subtype: '0',
      variant: '0',
    })],
    ['Gurgle', JSON.stringify({
      id: '87',
      subtype: '0',
      variant: '0',
    })],
    ['Walking Boil', JSON.stringify({
      id: '88',
      subtype: '0',
      variant: '0',
    })],
    ['Walking Gut', JSON.stringify({
      id: '88',
      subtype: '0',
      variant: '1',
    })],
    ['Walking Sack', JSON.stringify({
      id: '88',
      subtype: '0',
      variant: '2',
    })],
    ['Buttlicker', JSON.stringify({
      id: '89',
      subtype: '0',
      variant: '0',
    })],
    ['Hanger', JSON.stringify({
      id: '90',
      subtype: '0',
      variant: '0',
    })],
    ['Swarmer', JSON.stringify({
      id: '91',
      subtype: '0',
      variant: '0',
    })],
    ['Heart', JSON.stringify({
      id: '92',
      subtype: '0',
      variant: '0',
    })],
    ['Mask', JSON.stringify({
      id: '93',
      subtype: '0',
      variant: '0',
    })],
    ['Big Spider', JSON.stringify({
      id: '94',
      subtype: '0',
      variant: '0',
    })],
    ['Eternal Fly', JSON.stringify({
      id: '96',
      subtype: '0',
      variant: '0',
    })],
    ['Stone Eye', JSON.stringify({
      id: '201',
      subtype: '0',
      variant: '0',
    })],
    ['Constant Stone Shooter', JSON.stringify({
      id: '202',
      subtype: '0',
      variant: '0',
    })],
    ['Cross Stone Shooter', JSON.stringify({
      id: '202',
      subtype: '0',
      variant: '10',
    })],
    ['Cross Stone Shooter', JSON.stringify({
      id: '202',
      subtype: '1',
      variant: '10',
    })],
    ['Cross Stone Shooter (always on)', JSON.stringify({
      id: '202',
      subtype: '0',
      variant: '11',
    })],
    ['Cross Stone Shooter (always on)', JSON.stringify({
      id: '202',
      subtype: '1',
      variant: '11',
    })],
    ['Brimstone Head', JSON.stringify({
      id: '203',
      subtype: '0',
      variant: '0',
    })],
    ['Mobile Host', JSON.stringify({
      id: '204',
      subtype: '0',
      variant: '0',
    })],
    ['Nest', JSON.stringify({
      id: '205',
      subtype: '0',
      variant: '0',
    })],
    ['Baby Long Legs', JSON.stringify({
      id: '206',
      subtype: '0',
      variant: '0',
    })],
    ['Small Baby Long Legs', JSON.stringify({
      id: '206',
      subtype: '0',
      variant: '1',
    })],
    ['Crazy Long Legs', JSON.stringify({
      id: '207',
      subtype: '0',
      variant: '0',
    })],
    ['Small Crazy Long Legs', JSON.stringify({
      id: '207',
      subtype: '0',
      variant: '1',
    })],
    ['Fatty', JSON.stringify({
      id: '208',
      subtype: '0',
      variant: '0',
    })],
    ['Pale Fatty', JSON.stringify({
      id: '208',
      subtype: '0',
      variant: '1',
    })],
    ['Flaming Fatty', JSON.stringify({
      id: '208',
      subtype: '0',
      variant: '2',
    })],
    ['Fat Sack', JSON.stringify({
      id: '209',
      subtype: '0',
      variant: '0',
    })],
    ['Blubber', JSON.stringify({
      id: '210',
      subtype: '0',
      variant: '0',
    })],
    ['Half Sack', JSON.stringify({
      id: '211',
      subtype: '0',
      variant: '0',
    })],
    ['Death\'s Head', JSON.stringify({
      id: '212',
      subtype: '0',
      variant: '0',
    })],
    ['Dank Death\'s Head', JSON.stringify({
      id: '212',
      subtype: '0',
      variant: '1',
    })],
    ['Mom\'s Hand', JSON.stringify({
      id: '213',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Fly', JSON.stringify({
      id: '214',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Spider', JSON.stringify({
      id: '215',
      subtype: '0',
      variant: '0',
    })],
    ['Swinger', JSON.stringify({
      id: '216',
      subtype: '0',
      variant: '0',
    })],
    ['Swinger Head', JSON.stringify({
      id: '216',
      subtype: '0',
      variant: '1',
    })],
    ['Swinger Neck', JSON.stringify({
      id: '216',
      subtype: '0',
      variant: '10',
    })],
    ['Dip', JSON.stringify({
      id: '217',
      subtype: '0',
      variant: '0',
    })],
    ['Corn', JSON.stringify({
      id: '217',
      subtype: '0',
      variant: '1',
    })],
    ['Brownie Corn', JSON.stringify({
      id: '217',
      subtype: '0',
      variant: '2',
    })],
    ['Wall Hugger', JSON.stringify({
      id: '218',
      subtype: '0',
      variant: '0',
    })],
    ['Wizoob', JSON.stringify({
      id: '219',
      subtype: '0',
      variant: '0',
    })],
    ['Squirt', JSON.stringify({
      id: '220',
      subtype: '0',
      variant: '0',
    })],
    ['Dank Squirt', JSON.stringify({
      id: '220',
      subtype: '0',
      variant: '1',
    })],
    ['Cod Worm', JSON.stringify({
      id: '221',
      subtype: '0',
      variant: '0',
    })],
    ['Ring Fly', JSON.stringify({
      id: '222',
      subtype: '0',
      variant: '0',
    })],
    ['Dinga', JSON.stringify({
      id: '223',
      subtype: '0',
      variant: '0',
    })],
    ['Oob', JSON.stringify({
      id: '224',
      subtype: '0',
      variant: '0',
    })],
    ['Black Maw', JSON.stringify({
      id: '225',
      subtype: '0',
      variant: '0',
    })],
    ['Skinny', JSON.stringify({
      id: '226',
      subtype: '0',
      variant: '0',
    })],
    ['Rotty', JSON.stringify({
      id: '226',
      subtype: '0',
      variant: '1',
    })],
    ['Crispy', JSON.stringify({
      id: '226',
      subtype: '0',
      variant: '2',
    })],
    ['Bony', JSON.stringify({
      id: '227',
      subtype: '0',
      variant: '0',
    })],
    ['Homunculus', JSON.stringify({
      id: '228',
      subtype: '0',
      variant: '0',
    })],
    ['Homunculus Cord', JSON.stringify({
      id: '228',
      subtype: '0',
      variant: '10',
    })],
    ['Tumor', JSON.stringify({
      id: '229',
      subtype: '0',
      variant: '0',
    })],
    ['Camillo Jr.', JSON.stringify({
      id: '230',
      subtype: '0',
      variant: '0',
    })],
    ['Nerve Ending', JSON.stringify({
      id: '231',
      subtype: '0',
      variant: '0',
    })],
    ['Nerve Ending 2', JSON.stringify({
      id: '231',
      subtype: '0',
      variant: '1',
    })],
    ['One Tooth', JSON.stringify({
      id: '234',
      subtype: '0',
      variant: '0',
    })],
    ['Gaping Maw', JSON.stringify({
      id: '235',
      subtype: '0',
      variant: '0',
    })],
    ['Broken Gaping Maw', JSON.stringify({
      id: '236',
      subtype: '0',
      variant: '0',
    })],
    ['Gurgling', JSON.stringify({
      id: '237',
      subtype: '0',
      variant: '0',
    })],
    ['Splasher', JSON.stringify({
      id: '238',
      subtype: '0',
      variant: '0',
    })],
    ['Grub', JSON.stringify({
      id: '239',
      subtype: '0',
      variant: '0',
    })],
    ['Wall Creep', JSON.stringify({
      id: '240',
      subtype: '0',
      variant: '0',
    })],
    ['Rage Creep', JSON.stringify({
      id: '241',
      subtype: '0',
      variant: '0',
    })],
    ['Blind Creep', JSON.stringify({
      id: '242',
      subtype: '0',
      variant: '0',
    })],
    ['Conjoined Spitty', JSON.stringify({
      id: '243',
      subtype: '0',
      variant: '0',
    })],
    ['Round Worm', JSON.stringify({
      id: '244',
      subtype: '0',
      variant: '0',
    })],
    ['Tube Worm', JSON.stringify({
      id: '244',
      subtype: '0',
      variant: '1',
    })],
    ['Poop', JSON.stringify({
      id: '245',
      subtype: '0',
      variant: '0',
    })],
    ['Ragling', JSON.stringify({
      id: '246',
      subtype: '0',
      variant: '0',
    })],
    ['Rag Man\'s Ragling', JSON.stringify({
      id: '246',
      subtype: '0',
      variant: '1',
    })],
    ['Flesh Mobile Host', JSON.stringify({
      id: '247',
      subtype: '0',
      variant: '0',
    })],
    ['Psychic Horf', JSON.stringify({
      id: '248',
      subtype: '0',
      variant: '0',
    })],
    ['Full Fly', JSON.stringify({
      id: '249',
      subtype: '0',
      variant: '0',
    })],
    ['Ticking Spider', JSON.stringify({
      id: '250',
      subtype: '0',
      variant: '0',
    })],
    ['Begotten', JSON.stringify({
      id: '251',
      subtype: '0',
      variant: '0',
    })],
    ['Begotten Chain', JSON.stringify({
      id: '251',
      subtype: '0',
      variant: '10',
    })],
    ['Nulls', JSON.stringify({
      id: '252',
      subtype: '0',
      variant: '0',
    })],
    ['Psy Tumor', JSON.stringify({
      id: '253',
      subtype: '0',
      variant: '0',
    })],
    ['Floating Knight', JSON.stringify({
      id: '254',
      subtype: '0',
      variant: '0',
    })],
    ['Night Crawler', JSON.stringify({
      id: '255',
      subtype: '0',
      variant: '0',
    })],
    ['Dart Fly', JSON.stringify({
      id: '256',
      subtype: '0',
      variant: '0',
    })],
    ['Conjoined Fatty', JSON.stringify({
      id: '257',
      subtype: '0',
      variant: '0',
    })],
    ['Blue Conjoined Fatty', JSON.stringify({
      id: '257',
      subtype: '0',
      variant: '1',
    })],
    ['Fat Bat', JSON.stringify({
      id: '258',
      subtype: '0',
      variant: '0',
    })],
    ['Imp', JSON.stringify({
      id: '259',
      subtype: '0',
      variant: '0',
    })],
    ['Lil\' Haunt', JSON.stringify({
      id: '260',
      subtype: '0',
      variant: '10',
    })],
    ['Roundy', JSON.stringify({
      id: '276',
      subtype: '0',
      variant: '0',
    })],
    ['Black Bony', JSON.stringify({
      id: '277',
      subtype: '0',
      variant: '0',
    })],
    ['Black Globin', JSON.stringify({
      id: '278',
      subtype: '0',
      variant: '0',
    })],
    ['Black Globin\'s Head', JSON.stringify({
      id: '279',
      subtype: '0',
      variant: '0',
    })],
    ['Black Globin\'s Body', JSON.stringify({
      id: '280',
      subtype: '0',
      variant: '0',
    })],
    ['Swarm', JSON.stringify({
      id: '281',
      subtype: '0',
      variant: '0',
    })],
    ['Mega Clotty', JSON.stringify({
      id: '282',
      subtype: '0',
      variant: '0',
    })],
    ['Bone Knight', JSON.stringify({
      id: '283',
      subtype: '0',
      variant: '0',
    })],
    ['Cyclopia', JSON.stringify({
      id: '284',
      subtype: '0',
      variant: '0',
    })],
    ['Red Ghost', JSON.stringify({
      id: '285',
      subtype: '0',
      variant: '0',
    })],
    ['Flesh Death\'s Head', JSON.stringify({
      id: '286',
      subtype: '0',
      variant: '0',
    })],
    ['Mom\'s Dead Hand', JSON.stringify({
      id: '287',
      subtype: '0',
      variant: '0',
    })],
    ['Dukie', JSON.stringify({
      id: '288',
      subtype: '0',
      variant: '0',
    })],
    ['Ulcer', JSON.stringify({
      id: '289',
      subtype: '0',
      variant: '0',
    })],
    ['Meatball', JSON.stringify({
      id: '290',
      subtype: '0',
      variant: '0',
    })],
    ['Pitfall', JSON.stringify({
      id: '291',
      subtype: '0',
      variant: '0',
    })],
    ['Suction Pitfall', JSON.stringify({
      id: '291',
      subtype: '0',
      variant: '1',
    })],
    ['Teleport Pitfall', JSON.stringify({
      id: '291',
      subtype: '0',
      variant: '2',
    })],
    ['Movable TNT', JSON.stringify({
      id: '292',
      subtype: '0',
      variant: '0',
    })],
    ['Movable TNT (Mine Crafter)', JSON.stringify({
      id: '292',
      subtype: '0',
      variant: '1',
    })],
    ['Ultra Greed Coin (Spinner)', JSON.stringify({
      id: '293',
      subtype: '0',
      variant: '0',
    })],
    ['Ultra Greed Coin (Key)', JSON.stringify({
      id: '293',
      subtype: '0',
      variant: '1',
    })],
    ['Ultra Greed Coin (Bomb)', JSON.stringify({
      id: '293',
      subtype: '0',
      variant: '2',
    })],
    ['Ultra Greed Coin (Heart)', JSON.stringify({
      id: '293',
      subtype: '0',
      variant: '3',
    })],
    ['Corn Mine', JSON.stringify({
      id: '295',
      subtype: '0',
      variant: '0',
    })],
    ['Hush Fly', JSON.stringify({
      id: '296',
      subtype: '0',
      variant: '0',
    })],
    ['Blue Gaper', JSON.stringify({
      id: '297',
      subtype: '0',
      variant: '0',
    })],
    ['Blue Boil', JSON.stringify({
      id: '298',
      subtype: '0',
      variant: '0',
    })],
    ['Greed Gaper', JSON.stringify({
      id: '299',
      subtype: '0',
      variant: '0',
    })],
    ['Mushroom', JSON.stringify({
      id: '300',
      subtype: '0',
      variant: '0',
    })],
    ['Poison Mind', JSON.stringify({
      id: '301',
      subtype: '0',
      variant: '0',
    })],
    ['Stoney', JSON.stringify({
      id: '302',
      subtype: '0',
      variant: '0',
    })],
    ['Cross Stoney', JSON.stringify({
      id: '302',
      subtype: '0',
      variant: '10',
    })],
    ['Blister', JSON.stringify({
      id: '303',
      subtype: '0',
      variant: '0',
    })],
    ['The Thing', JSON.stringify({
      id: '304',
      subtype: '0',
      variant: '0',
    })],
    ['Ministro', JSON.stringify({
      id: '305',
      subtype: '0',
      variant: '0',
    })],
    ['Portal', JSON.stringify({
      id: '306',
      subtype: '0',
      variant: '0',
    })],
    ['Tar Boy', JSON.stringify({
      id: '307',
      subtype: '0',
      variant: '0',
    })],
    ['Tar Boy (mouth)', JSON.stringify({
      id: '307',
      subtype: '1',
      variant: '0',
    })],
    ['Fistuloid', JSON.stringify({
      id: '308',
      subtype: '0',
      variant: '0',
    })],
    ['Gush', JSON.stringify({
      id: '309',
      subtype: '0',
      variant: '0',
    })],
    ['Leper', JSON.stringify({
      id: '310',
      subtype: '0',
      variant: '0',
    })],
    ['Leper (stage 2)', JSON.stringify({
      id: '310',
      subtype: '1',
      variant: '0',
    })],
    ['Leper (stage 3)', JSON.stringify({
      id: '310',
      subtype: '2',
      variant: '0',
    })],
    ['Leper (stage 4)', JSON.stringify({
      id: '310',
      subtype: '3',
      variant: '0',
    })],
    ['Leper Flesh', JSON.stringify({
      id: '310',
      subtype: '0',
      variant: '1',
    })],
    ['Mr. Mine', JSON.stringify({
      id: '311',
      subtype: '0',
      variant: '0',
    })],
    ['Mr. Mine Neck', JSON.stringify({
      id: '311',
      subtype: '0',
      variant: '10',
    })],
    ['Dark Ball', JSON.stringify({
      id: '404',
      subtype: '0',
      variant: '1',
    })],
    ['Rag Man\'s Head', JSON.stringify({
      id: '405',
      subtype: '0',
      variant: '1',
    })],
    ['Purple Ball', JSON.stringify({
      id: '409',
      subtype: '0',
      variant: '1',
    })],
    ['Rag Mega\'s Rebirth Pillar', JSON.stringify({
      id: '409',
      subtype: '0',
      variant: '2',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '0',
      variant: '3',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '1',
      variant: '3',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '2',
      variant: '3',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '3',
      variant: '3',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '4',
      variant: '3',
    })],
    ['Rotten Gaper', JSON.stringify({
      id: '10',
      subtype: '5',
      variant: '3',
    })],
    ['Tainted Pooter', JSON.stringify({
      id: '14',
      subtype: '0',
      variant: '2',
    })],
    ['Grilled Clotty', JSON.stringify({
      id: '15',
      subtype: '0',
      variant: '3',
    })],
    ['Holy Mulligan', JSON.stringify({
      id: '22',
      subtype: '0',
      variant: '2',
    })],
    ['Tainted Mulligan', JSON.stringify({
      id: '22',
      subtype: '0',
      variant: '3',
    })],
    ['Carrion Princess', JSON.stringify({
      id: '23',
      subtype: '0',
      variant: '3',
    })],
    ['Cursed Globin', JSON.stringify({
      id: '24',
      subtype: '0',
      variant: '3',
    })],
    ['Dragon Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '3',
    })],
    ['Dragon Fly X', JSON.stringify({
      id: '25',
      subtype: '1',
      variant: '3',
    })],
    ['Bone Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '4',
    })],
    ['Sick Boom Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '5',
    })],
    ['Tainted Boom Fly', JSON.stringify({
      id: '25',
      subtype: '0',
      variant: '6',
    })],
    ['Hard Host', JSON.stringify({
      id: '27',
      subtype: '0',
      variant: '3',
    })],
    ['Eggy', JSON.stringify({
      id: '29',
      subtype: '0',
      variant: '2',
    })],
    ['Tainted Hopper', JSON.stringify({
      id: '29',
      subtype: '0',
      variant: '3',
    })],
    ['Tainted Spitty', JSON.stringify({
      id: '31',
      subtype: '0',
      variant: '1',
    })],
    ['White Fire Place', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '4',
    })],
    ['Moveable Fireplace', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '10',
    })],
    ['Moveable Blue Fireplace', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '12',
    })],
    ['Moveable Purple Fireplace', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '13',
    })],
    ['Sticky Leaper', JSON.stringify({
      id: '34',
      subtype: '0',
      variant: '1',
    })],
    ['Angelic Baby (small)', JSON.stringify({
      id: '38',
      subtype: '1',
      variant: '1',
    })],
    ['Wrinkly Baby', JSON.stringify({
      id: '38',
      subtype: '0',
      variant: '3',
    })],
    ['Holy Eye', JSON.stringify({
      id: '60',
      subtype: '0',
      variant: '2',
    })],
    ['Crackle', JSON.stringify({
      id: '87',
      subtype: '0',
      variant: '1',
    })],
    ['Holy Bony', JSON.stringify({
      id: '227',
      subtype: '0',
      variant: '1',
    })],
    ['Planetoid', JSON.stringify({
      id: '229',
      subtype: '0',
      variant: '1',
    })],
    ['Tainted Round Worm', JSON.stringify({
      id: '244',
      subtype: '0',
      variant: '2',
    })],
    ['Tainted Round Worm Butt', JSON.stringify({
      id: '244',
      subtype: '1',
      variant: '2',
    })],
    ['Tainted Tube Worm', JSON.stringify({
      id: '244',
      subtype: '0',
      variant: '3',
    })],
    ['Coal', JSON.stringify({
      id: '33',
      subtype: '0',
      variant: '11',
    })],
    ['Coal', JSON.stringify({
      id: '33',
      subtype: '1',
      variant: '11',
    })],
    ['Coal', JSON.stringify({
      id: '33',
      subtype: '2',
      variant: '11',
    })],
    ['Coal', JSON.stringify({
      id: '33',
      subtype: '3',
      variant: '11',
    })],
    ['Slog', JSON.stringify({
      id: '40',
      subtype: '0',
      variant: '2',
    })],
    ['Loose Knight', JSON.stringify({
      id: '41',
      subtype: '0',
      variant: '2',
    })],
    ['Brainless Knight', JSON.stringify({
      id: '41',
      subtype: '0',
      variant: '3',
    })],
    ['Black Knight', JSON.stringify({
      id: '41',
      subtype: '0',
      variant: '4',
    })],
    ['Triple Grimace', JSON.stringify({
      id: '42',
      subtype: '0',
      variant: '2',
    })],
    ['Ink', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '3',
    })],
    ['Dead Meat', JSON.stringify({
      id: '57',
      subtype: '0',
      variant: '2',
    })],
    ['Mama Fly', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '4',
    })],
    ['Bulb', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '5',
    })],
    ['Bloodfly', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '6',
    })],
    ['Tainted Sucker', JSON.stringify({
      id: '61',
      subtype: '0',
      variant: '7',
    })],
    ['1/2 Heart', JSON.stringify({
      id: '92',
      subtype: '0',
      variant: '1',
    })],
    ['1/2 Heart', JSON.stringify({
      id: '92',
      subtype: '1',
      variant: '1',
    })],
    ['Mask II', JSON.stringify({
      id: '93',
      subtype: '0',
      variant: '1',
    })],
    ['Cursed Death\'s Head', JSON.stringify({
      id: '212',
      subtype: '0',
      variant: '2',
    })],
    ['Brimstone Death\'s Head', JSON.stringify({
      id: '212',
      subtype: '0',
      variant: '3',
    })],
    ['Redskull', JSON.stringify({
      id: '212',
      subtype: '0',
      variant: '4',
    })],
    ['Corpse Eater', JSON.stringify({
      id: '239',
      subtype: '0',
      variant: '100',
    })],
    ['Carrion Rider', JSON.stringify({
      id: '239',
      subtype: '0',
      variant: '101',
    })],
    ['Soy Creep', JSON.stringify({
      id: '240',
      subtype: '0',
      variant: '1',
    })],
    ['Rag Creep', JSON.stringify({
      id: '240',
      subtype: '0',
      variant: '2',
    })],
    ['Tainted Soy Creep', JSON.stringify({
      id: '240',
      subtype: '0',
      variant: '3',
    })],
    ['Split Rage Creep', JSON.stringify({
      id: '241',
      subtype: '0',
      variant: '1',
    })],
    ['Lil Portal', JSON.stringify({
      id: '306',
      subtype: '0',
      variant: '1',
    })],
    ['Blood Puppy', JSON.stringify({
      id: '802',
      subtype: '0',
      variant: '0',
    })],
    ['Blood Puppy', JSON.stringify({
      id: '802',
      subtype: '0',
      variant: '1',
    })],
    ['Blind Bat', JSON.stringify({
      id: '803',
      subtype: '0',
      variant: '0',
    })],
    ['Quake Grimace', JSON.stringify({
      id: '804',
      subtype: '0',
      variant: '0',
    })],
    ['Quake Grimace', JSON.stringify({
      id: '804',
      subtype: '1',
      variant: '0',
    })],
    ['Quake Grimace', JSON.stringify({
      id: '804',
      subtype: '2',
      variant: '0',
    })],
    ['Quake Grimace', JSON.stringify({
      id: '804',
      subtype: '3',
      variant: '0',
    })],
    ['Bishop', JSON.stringify({
      id: '805',
      subtype: '0',
      variant: '0',
    })],
    ['Bubbles', JSON.stringify({
      id: '806',
      subtype: '0',
      variant: '0',
    })],
    ['Wraith', JSON.stringify({
      id: '807',
      subtype: '0',
      variant: '0',
    })],
    ['Willo', JSON.stringify({
      id: '808',
      subtype: '0',
      variant: '0',
    })],
    ['Bomb Grimace', JSON.stringify({
      id: '809',
      subtype: '0',
      variant: '0',
    })],
    ['Small Leech', JSON.stringify({
      id: '810',
      subtype: '0',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '0',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '1',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '2',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '3',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '4',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '5',
      variant: '0',
    })],
    ['Deep Gaper', JSON.stringify({
      id: '811',
      subtype: '6',
      variant: '0',
    })],
    ['Sub Horf', JSON.stringify({
      id: '812',
      subtype: '0',
      variant: '0',
    })],
    ['Tainted Sub Horf', JSON.stringify({
      id: '812',
      subtype: '0',
      variant: '1',
    })],
    ['Blurb', JSON.stringify({
      id: '813',
      subtype: '0',
      variant: '0',
    })],
    ['Strider', JSON.stringify({
      id: '814',
      subtype: '0',
      variant: '0',
    })],
    ['Fissure', JSON.stringify({
      id: '815',
      subtype: '0',
      variant: '0',
    })],
    ['Polty', JSON.stringify({
      id: '816',
      subtype: '0',
      variant: '0',
    })],
    ['Kineti', JSON.stringify({
      id: '816',
      subtype: '0',
      variant: '1',
    })],
    ['Prey', JSON.stringify({
      id: '817',
      subtype: '0',
      variant: '0',
    })],
    ['Mullighoul', JSON.stringify({
      id: '817',
      subtype: '0',
      variant: '1',
    })],
    ['Rock Spider', JSON.stringify({
      id: '818',
      subtype: '0',
      variant: '0',
    })],
    ['Rock Spider', JSON.stringify({
      id: '818',
      subtype: '1',
      variant: '0',
    })],
    ['Rock Spider', JSON.stringify({
      id: '818',
      subtype: '2',
      variant: '0',
    })],
    ['Rock Spider', JSON.stringify({
      id: '818',
      subtype: '3',
      variant: '0',
    })],
    ['Tinted Rock Spider', JSON.stringify({
      id: '818',
      subtype: '0',
      variant: '1',
    })],
    ['Tinted Rock Spider', JSON.stringify({
      id: '818',
      subtype: '1',
      variant: '1',
    })],
    ['Tinted Rock Spider', JSON.stringify({
      id: '818',
      subtype: '2',
      variant: '1',
    })],
    ['Tinted Rock Spider', JSON.stringify({
      id: '818',
      subtype: '3',
      variant: '1',
    })],
    ['Coal Spider', JSON.stringify({
      id: '818',
      subtype: '0',
      variant: '2',
    })],
    ['Coal Spider', JSON.stringify({
      id: '818',
      subtype: '1',
      variant: '2',
    })],
    ['Coal Spider', JSON.stringify({
      id: '818',
      subtype: '2',
      variant: '2',
    })],
    ['Coal Spider', JSON.stringify({
      id: '818',
      subtype: '3',
      variant: '2',
    })],
    ['Fly Bomb', JSON.stringify({
      id: '819',
      subtype: '0',
      variant: '0',
    })],
    ['Eternal Fly Bomb', JSON.stringify({
      id: '819',
      subtype: '0',
      variant: '1',
    })],
    ['Danny', JSON.stringify({
      id: '820',
      subtype: '0',
      variant: '0',
    })],
    ['Coal Boy', JSON.stringify({
      id: '820',
      subtype: '0',
      variant: '1',
    })],
    ['Blaster', JSON.stringify({
      id: '821',
      subtype: '0',
      variant: '0',
    })],
    ['Bouncer', JSON.stringify({
      id: '822',
      subtype: '0',
      variant: '0',
    })],
    ['Quakey', JSON.stringify({
      id: '823',
      subtype: '0',
      variant: '0',
    })],
    ['Gyro', JSON.stringify({
      id: '824',
      subtype: '0',
      variant: '0',
    })],
    ['Grilled Gyro', JSON.stringify({
      id: '824',
      subtype: '0',
      variant: '1',
    })],
    ['Fire Worm', JSON.stringify({
      id: '825',
      subtype: '0',
      variant: '0',
    })],
    ['Hardy', JSON.stringify({
      id: '826',
      subtype: '0',
      variant: '0',
    })],
    ['Faceless', JSON.stringify({
      id: '827',
      subtype: '0',
      variant: '0',
    })],
    ['Tainted Faceless', JSON.stringify({
      id: '827',
      subtype: '0',
      variant: '1',
    })],
    ['Necro', JSON.stringify({
      id: '828',
      subtype: '0',
      variant: '0',
    })],
    ['Mole', JSON.stringify({
      id: '829',
      subtype: '0',
      variant: '0',
    })],
    ['Tainted Mole', JSON.stringify({
      id: '829',
      subtype: '0',
      variant: '1',
    })],
    ['Big Bony', JSON.stringify({
      id: '830',
      subtype: '0',
      variant: '0',
    })],
    ['Big Bone', JSON.stringify({
      id: '830',
      subtype: '0',
      variant: '10',
    })],
    ['Gutted Fatty', JSON.stringify({
      id: '831',
      subtype: '0',
      variant: '0',
    })],
    ['Gutted Fatty Eye', JSON.stringify({
      id: '831',
      subtype: '0',
      variant: '10',
    })],
    ['Festering Guts', JSON.stringify({
      id: '831',
      subtype: '0',
      variant: '20',
    })],
    ['Exorcist', JSON.stringify({
      id: '832',
      subtype: '0',
      variant: '0',
    })],
    ['Fanatic', JSON.stringify({
      id: '832',
      subtype: '0',
      variant: '1',
    })],
    ['Candler', JSON.stringify({
      id: '833',
      subtype: '0',
      variant: '0',
    })],
    ['Whipper', JSON.stringify({
      id: '834',
      subtype: '0',
      variant: '0',
    })],
    ['Snapper', JSON.stringify({
      id: '834',
      subtype: '0',
      variant: '1',
    })],
    ['Flagellant', JSON.stringify({
      id: '834',
      subtype: '0',
      variant: '2',
    })],
    ['Peeping Fatty', JSON.stringify({
      id: '835',
      subtype: '0',
      variant: '0',
    })],
    ['Peeping Fatty Eye', JSON.stringify({
      id: '835',
      subtype: '0',
      variant: '10',
    })],
    ['Vis Versa', JSON.stringify({
      id: '836',
      subtype: '0',
      variant: '0',
    })],
    ['Henry', JSON.stringify({
      id: '837',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Willo', JSON.stringify({
      id: '838',
      subtype: '0',
      variant: '0',
    })],
    ['Strifer', JSON.stringify({
      id: '839',
      subtype: '0',
      variant: '0',
    })],
    ['Pon', JSON.stringify({
      id: '840',
      subtype: '0',
      variant: '0',
    })],
    ['Revenant', JSON.stringify({
      id: '841',
      subtype: '0',
      variant: '0',
    })],
    ['Quad Revenant', JSON.stringify({
      id: '841',
      subtype: '0',
      variant: '1',
    })],
    ['Nightwatch', JSON.stringify({
      id: '842',
      subtype: '0',
      variant: '0',
    })],
    ['Canary', JSON.stringify({
      id: '843',
      subtype: '0',
      variant: '0',
    })],
    ['Foreigner', JSON.stringify({
      id: '843',
      subtype: '0',
      variant: '1',
    })],
    ['Bombgagger', JSON.stringify({
      id: '844',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Gaper', JSON.stringify({
      id: '850',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Horf', JSON.stringify({
      id: '850',
      subtype: '0',
      variant: '1',
    })],
    ['Level 2 Gusher', JSON.stringify({
      id: '850',
      subtype: '0',
      variant: '2',
    })],
    ['Twitchy', JSON.stringify({
      id: '851',
      subtype: '0',
      variant: '0',
    })],
    ['Spikeball', JSON.stringify({
      id: '852',
      subtype: '0',
      variant: '0',
    })],
    ['Small Maggot', JSON.stringify({
      id: '853',
      subtype: '0',
      variant: '0',
    })],
    ['Adult Leech', JSON.stringify({
      id: '854',
      subtype: '0',
      variant: '0',
    })],
    ['Level 2 Charger', JSON.stringify({
      id: '855',
      subtype: '0',
      variant: '0',
    })],
    ['Elleech', JSON.stringify({
      id: '855',
      subtype: '0',
      variant: '1',
    })],
    ['Gasbag', JSON.stringify({
      id: '856',
      subtype: '0',
      variant: '0',
    })],
    ['Cohort', JSON.stringify({
      id: '857',
      subtype: '0',
      variant: '0',
    })],
    ['Floating Host', JSON.stringify({
      id: '859',
      subtype: '0',
      variant: '0',
    })],
    ['Unborn', JSON.stringify({
      id: '860',
      subtype: '0',
      variant: '0',
    })],
    ['Pustule', JSON.stringify({
      id: '861',
      subtype: '0',
      variant: '0',
    })],
    ['Cyst', JSON.stringify({
      id: '862',
      subtype: '0',
      variant: '0',
    })],
    ['Morningstar', JSON.stringify({
      id: '863',
      subtype: '0',
      variant: '0',
    })],
    ['Mockulus', JSON.stringify({
      id: '864',
      subtype: '0',
      variant: '0',
    })],
    ['Evis', JSON.stringify({
      id: '865',
      subtype: '0',
      variant: '0',
    })],
    ['Evis Guts', JSON.stringify({
      id: '865',
      subtype: '0',
      variant: '10',
    })],
    ['Army Fly', JSON.stringify({
      id: '868',
      subtype: '0',
      variant: '0',
    })],
    ['Migraine', JSON.stringify({
      id: '869',
      subtype: '0',
      variant: '0',
    })],
    ['Drip', JSON.stringify({
      id: '870',
      subtype: '0',
      variant: '0',
    })],
    ['Splurt', JSON.stringify({
      id: '871',
      subtype: '0',
      variant: '0',
    })],
    ['Cloggy', JSON.stringify({
      id: '872',
      subtype: '0',
      variant: '0',
    })],
    ['Fly Trap', JSON.stringify({
      id: '873',
      subtype: '0',
      variant: '0',
    })],
    ['Fartigan', JSON.stringify({
      id: '874',
      subtype: '0',
      variant: '0',
    })],
    ['Big Corn', JSON.stringify({
      id: '217',
      subtype: '0',
      variant: '3',
    })],
    ['Poot Mine', JSON.stringify({
      id: '875',
      subtype: '0',
      variant: '0',
    })],
    ['Dump', JSON.stringify({
      id: '876',
      subtype: '0',
      variant: '0',
    })],
    ['Dump Head', JSON.stringify({
      id: '876',
      subtype: '0',
      variant: '1',
    })],
    ['Grudge', JSON.stringify({
      id: '877',
      subtype: '0',
      variant: '0',
    })],
    ['Butt Slicker', JSON.stringify({
      id: '878',
      subtype: '0',
      variant: '0',
    })],
    ['Bloaty', JSON.stringify({
      id: '879',
      subtype: '0',
      variant: '0',
    })],
    ['Flesh Maiden', JSON.stringify({
      id: '880',
      subtype: '0',
      variant: '0',
    })],
    ['Needle', JSON.stringify({
      id: '881',
      subtype: '0',
      variant: '0',
    })],
    ['Pasty', JSON.stringify({
      id: '881',
      subtype: '0',
      variant: '1',
    })],
    ['Dust', JSON.stringify({
      id: '882',
      subtype: '0',
      variant: '0',
    })],
    ['Baby Begotten', JSON.stringify({
      id: '883',
      subtype: '0',
      variant: '0',
    })],
    ['Swarm Spider', JSON.stringify({
      id: '884',
      subtype: '0',
      variant: '0',
    })],
    ['Cultist', JSON.stringify({
      id: '885',
      subtype: '0',
      variant: '0',
    })],
    ['Blood Cultist', JSON.stringify({
      id: '885',
      subtype: '0',
      variant: '1',
    })],
    ['Bone Trap', JSON.stringify({
      id: '885',
      subtype: '0',
      variant: '10',
    })],
    ['Vis Fatty', JSON.stringify({
      id: '886',
      subtype: '0',
      variant: '0',
    })],
    ['Fetal Demon', JSON.stringify({
      id: '886',
      subtype: '0',
      variant: '1',
    })],
    ['Shady', JSON.stringify({
      id: '888',
      subtype: '0',
      variant: '0',
    })],
    ['Clickety Clack', JSON.stringify({
      id: '889',
      subtype: '0',
      variant: '0',
    })],
    ['Maze Roamer', JSON.stringify({
      id: '890',
      subtype: '0',
      variant: '0',
    })],
    ['Maze Roamer', JSON.stringify({
      id: '890',
      subtype: '1',
      variant: '0',
    })],
    ['Goat', JSON.stringify({
      id: '891',
      subtype: '0',
      variant: '0',
    })],
    ['Black Goat', JSON.stringify({
      id: '891',
      subtype: '0',
      variant: '1',
    })],
    ['Poofer', JSON.stringify({
      id: '892',
      subtype: '0',
      variant: '0',
    })],
    ['Ball and Chain', JSON.stringify({
      id: '893',
      subtype: '0',
      variant: '0',
    })],
    ['Dead Isaac', JSON.stringify({
      id: '912',
      subtype: '0',
      variant: '20',
    })],
    ['Beast Soul', JSON.stringify({
      id: '951',
      subtype: '0',
      variant: '3',
    })],
    ['Dummy', JSON.stringify({
      id: '964',
      subtype: '0',
      variant: '0',
    })],
  ]
  